import { memo } from "react";

const TopbarSearch = memo(({ searchPlaceholder, searchTerm, setSearchTerm, isListening, isVoiceSupported, onSearchSubmit, onSearchKeyDown, onVoiceInput }) => {
  return (
    <div className="landing-search-wrapper landing-search-wrapper--desktop surface-card border-1 surface-border shadow-1">
      <div className="landing-search-box">
        <button
          type="button"
          className="landing-search-submit p-link"
          aria-label="Buscar productos"
          onClick={onSearchSubmit}
        >
          <i className="pi pi-search"></i>
        </button>
        <input
          type="text"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          onKeyDown={onSearchKeyDown}
          placeholder={searchPlaceholder || "Busca por palabra clave, producto o código..."}
          aria-label="Buscar productos"
        />
        <button
          type="button"
          className={`landing-search-mic ${isListening ? "is-listening" : ""}`.trim()}
          aria-label={isListening ? "Detener dictado por voz" : "Iniciar dictado por voz"}
          onClick={onVoiceInput}
          aria-disabled={!isVoiceSupported}
        >
          <i className={`pi ${isListening ? "pi-stop-circle" : "pi-microphone"}`}></i>
        </button>
      </div>
    </div>
  );
});

export default TopbarSearch;
